'use strict';

const zeroPrefixInteger = integer => integer < 10 ? `0${integer}` : `${integer}`;
const formatToIso = time => {
  if (typeof time === 'string') {
    const [hours, minutes, seconds = '00'] = time.split(':');
    return `${hours}:${minutes}:${seconds}`;
  }
  if (Array.isArray(time)) {
    const [hours, minutes = 0, seconds = 0] = time;
    return `${zeroPrefixInteger(hours)}:${zeroPrefixInteger(minutes)}:${zeroPrefixInteger(seconds)}`;
  }
  return null;
};
const formatToHoursMinutes = timeString => timeString.slice(0, 5);
const formatTimeFromHoursMinutes = time => `${time}:00`;
const convertTimeToInteger = time => time.split(':').join('');
const addMinutes = (time, minutesToAdd) => {
  const [hours, minutes, seconds] = time.split(':');
  let newHours = Number(hours);
  let newMinutes = Number(minutes) + Number(minutesToAdd);
  while (newMinutes >= 60) {
    newHours += 1;
    if (newHours === 24) {
      newHours = 0;
    }
    newMinutes -= 60;
  }
  return formatToIso([newHours, newMinutes, Number(seconds)]);
};
const calculateDurationInHours = (startTime, endTime) => {
  const [startHours, startMinutes] = startTime.split(':');
  const [endHours, endMinutes] = endTime.split(':');
  const hours = endHours - startHours;
  const minutes = endMinutes - startMinutes;
  const duration = hours + minutes / 60;
  return duration.toFixed(2);
};
const calculateDurationInMinutes = (startTime, endTime) => {
  const [startHours, startMinutes] = startTime.split(':');
  const [endHours, endMinutes] = endTime.split(':');
  const hours = endHours - startHours;
  const minutes = endMinutes - startMinutes;
  return hours * 60 + minutes;
};
const calculateHoursMinutesFromDuration = duration => ({
  hours: Math.floor(duration / 60),
  minutes: duration % 60
});
const timeIsBefore = (time, referenceTime) => convertTimeToInteger(time) < convertTimeToInteger(referenceTime);
const timeIsBeforeInclusive = (time, referenceTime) => convertTimeToInteger(time) <= convertTimeToInteger(referenceTime);
const timeIsAfter = (time, referenceTime) => convertTimeToInteger(time) > convertTimeToInteger(referenceTime);
const timeIsAfterInclusive = (time, referenceTime) => convertTimeToInteger(time) >= convertTimeToInteger(referenceTime);
const timeIsBetween = (time, firstReferenceTime, secondReferenceTime) => timeIsAfter(time, firstReferenceTime) && timeIsBefore(time, secondReferenceTime);
const timesAreBetweenInclusive = (firstTime, secondTime, firstReferenceTime, secondReferenceTime) => timeIsAfterInclusive(firstTime, firstReferenceTime) && timeIsBeforeInclusive(secondTime, secondReferenceTime);
module.exports = {
  formatToIso,
  formatToHoursMinutes,
  formatTimeFromHoursMinutes,
  convertTimeToInteger,
  addMinutes,
  calculateDurationInHours,
  calculateDurationInMinutes,
  calculateHoursMinutesFromDuration,
  timeIsBefore,
  timeIsBeforeInclusive,
  timeIsAfter,
  timeIsAfterInclusive,
  timeIsBetween,
  timesAreBetweenInclusive
};